module.exports = __webpack_public_path__ + "media/img/screenshot-inbox-6d35ae0a87e8460fb7be61ea13b874c8.svg";